/**
 * Einheitlicher Zurück-Button, der IMMER zum Dashboard navigiert.
 * Keine Browser-History-Navigation mehr.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

/**
 * @param {Object} props
 * @param {string} [props.label] - Button-Text (default: "Zurück")
 * @param {string} [props.className] - Zusätzliche CSS-Klassen
 * @param {string} [props.variant] - Button-Variante (default: "outline")
 * @param {string} [props.size] - Button-Größe (default: "sm")
 * @param {string} [props.to] - Ziel-Route (default: "/" = Dashboard)
 */
const BackButton = ({ 
  label = 'Zurück', 
  className = '', 
  variant = 'outline',
  size = 'sm',
  to = '/',
  ...props 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    // IMMER zum Dashboard navigieren, nicht Browser-History
    navigate(to);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      className={`flex items-center space-x-2 ${className}`}
      data-testid="back-button"
      {...props}
    >
      <ArrowLeft size={16} />
      <span>{label}</span>
    </Button>
  );
};

export default BackButton;
